import React from 'react'
import { useViews } from 'state'
import { ChatBubble, ChatBubbleOutline } from '@material-ui/icons'
import { RoundedButton } from '../Kit/Buttons'
import { ButtonBubble } from './ButtonBubble'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useAmplifyChat } from '@gojiraf/chat'

export const ChatButton = () => {
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { state, send } = useViews()
  const { dispatch: chatDispatch, state: chatState } = useAmplifyChat()

  const openChat = () => {
    postHogTrackEvent('toggle-chat-button')
    send({
      type: 'SHOW_CHAT',
    })
    chatDispatch({
      type: 'resetNewMessagesCount',
    })
  }

  const ChatIcon = () =>
    state.matches('secondary.showingChat') === true ? <ChatBubble /> : <ChatBubbleOutline />

  return (
    <RoundedButton
      color="secondary"
      onClick={openChat}
      id="toggle-chat-button"
      data-test="toggle-chat-button"
    >
      {chatState.newMessagesCount && state.matches('secondary.showingChat') !== true ? (
        <ButtonBubble badgeContent={chatState.newMessagesCount} color="error">
          <ChatIcon />
        </ButtonBubble>
      ) : (
        <ChatIcon />
      )}
    </RoundedButton>
  )
}
